import { forwardRef, useImperativeHandle, useState } from "react"
import { Modal, Box } from "@mui/material"
import styles from "../Modals.module.css"
import ModalCloseButton from "../ModalCloseButton"
import ReflectPost from "./ReflectPost"

const ReflectionModal = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false)

  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      <>
        <ModalCloseButton handleClose={handleClose} />
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "background.paper",
            borderRadius: "0.8rem",
            boxShadow: 24,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ReflectPost
            wisdom={props?.wisdom ?? { quote: "", question: "" }}
            handleClose={handleClose}
          />
        </Box>
      </>
    </Modal>
  )
})

export default ReflectionModal
